import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
var _excluded = ["value", "defaultChecked", "onChange", "checked", "isError", "disabled", "theme", "size", "mode"];
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { GroupContext } from './group-context.js';
import CheckboxControlInner from './checkbox-control-inner.js';
var CheckboxControl = /*#__PURE__*/React.forwardRef(function CheckboxControl(props, ref) {
  return /*#__PURE__*/React.createElement(GroupContext.Consumer, null, function (_ref) {
    var inGroup = _ref.inGroup,
        handleCheckboxChange = _ref.handleCheckboxChange,
        groupValue = _ref.value,
        isError = _ref.isError,
        theme = _ref.theme,
        size = _ref.size,
        mode = _ref.mode,
        disabled = _ref.disabled;

    if (!inGroup) {
      return /*#__PURE__*/React.createElement(CheckboxControlInner, _objectSpread({
        ref: ref
      }, props));
    }

    var value = props.value,
        defaultChecked = props.defaultChecked,
        onChange = props.onChange,
        checked = props.checked,
        propsIsError = props.isError,
        propsDisabled = props.disabled,
        propsTheme = props.theme,
        propsSize = props.size,
        propsMode = props.mode,
        restProps = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/React.createElement(CheckboxControlInner, _objectSpread({
      isError: isError || propsIsError,
      value: value,
      onChange: handleCheckboxChange,
      checked: _includesInstanceProperty(groupValue).call(groupValue, value),
      disabled: disabled || propsDisabled,
      theme: theme || propsTheme,
      size: size || propsSize,
      mode: mode || propsMode,
      ref: ref
    }, restProps));
  });
});
CheckboxControl.propTypes = CheckboxControlInner.propTypes;
export { CheckboxControl as default };
